/**
 * Copyright 2023-2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { FlexContainer, Tab, Tabs as TabContainer } from "@nordcloud/gnui";
import { useActionTabNavigation } from "~/hooks";
import { isNotEmpty } from "~/tools";
import { usePlan } from "~/views/plans/PlanDetails/PlanProvider";
import { ActionNotification } from "./ActionNotification";
import { AdvancedSettings } from "./AdvancedSettings";
import { GeneralSettings } from "./GeneralSettings";
import { TabIcon } from "./TabIcon";

const ACTION_TAB_STEP_MAPPING: Record<string, number> = {
  general: 0,
  advanced: 1,
  notifications: 2,
};

export function ActionView() {
  const { planAction } = usePlan();
  const { currentStep, handleTab } = useActionTabNavigation(
    ACTION_TAB_STEP_MAPPING
  );
  const hasNotifications = isNotEmpty(planAction?.notificationGroups ?? []);

  return (
    <>
      <FlexContainer alignItems="stretch" css={{ flex: 1, minWidth: "10rem" }}>
        <TabContainer step={currentStep} handleTab={handleTab}>
          <Tab
            data-testid="tab-general-action-settings"
            label={
              <span>
                <TabIcon caption="General Action Settings" icon="settings" />
              </span>
            }
            width="auto"
            css={{ minHeight: "13rem" }}
          >
            <GeneralSettings />
          </Tab>
          <Tab
            data-testid="tab-advanced-action-settings"
            label={
              <TabIcon caption="Advanced Action Settings" icon="doubleGear" />
            }
            width="auto"
            css={{ minHeight: "13rem" }}
          >
            <AdvancedSettings />
          </Tab>
          <Tab
            data-testid="tab-action-notifications"
            label={
              <TabIcon
                caption="Resource and Action-based Notifications"
                icon={hasNotifications ? "bellActive" : "bell"}
              />
            }
            width="auto"
            css={{ minHeight: "13rem" }}
          >
            <ActionNotification />
          </Tab>
        </TabContainer>
      </FlexContainer>
    </>
  );
}
